import React, { useEffect, useRef } from "react";
import couponDiscount from '../img/other/discount.png';

const AppliedCouponAlert = ({ AppliedCouponPopup, DisplayCouponCode, CouponDiscountPrice, onClose, onConfirm }) => {
  const canvasRef = useRef(null);
  const animFrameRef = useRef(null);
  const particlesRef = useRef([]);

  useEffect(() => {
    if (!AppliedCouponPopup) return;

    const canvas = canvasRef.current;
    const ctx = canvas.getContext("2d");
    canvas.width = window.innerWidth;
    canvas.height = window.innerHeight;

    const COLORS = ["#da251c", "#ffc107", "#00ce75", "#4f5ac2", "#ffffff", "#ff6b6b", "#FFD700"];
    const PARTICLE_COUNT = 150;

    // Create particles
    particlesRef.current = Array.from({ length: PARTICLE_COUNT }, () => ({
      x: Math.random() * canvas.width,
      y: Math.random() * canvas.height * 0.5 - canvas.height * 0.1,
      w: Math.random() * 10 + 5,
      h: Math.random() * 5 + 3,
      color: COLORS[Math.floor(Math.random() * COLORS.length)],
      rotation: Math.random() * 360,
      rotationSpeed: (Math.random() - 0.5) * 6,
      vx: (Math.random() - 0.5) * 4,
      vy: Math.random() * 3 + 2,
      opacity: 1,
      shape: Math.random() > 0.5 ? "rect" : "circle",
    }));

    const draw = () => {
      ctx.clearRect(0, 0, canvas.width, canvas.height);

      let allDone = true;

      particlesRef.current.forEach((p) => {
        p.x += p.vx;
        p.y += p.vy;
        p.rotation += p.rotationSpeed;
        p.vy += 0.05; // gravity
        if (p.y < canvas.height + 20) allDone = false;

        ctx.save();
        ctx.globalAlpha = Math.max(0, p.opacity - Math.max(0, (p.y - canvas.height * 0.7) / canvas.height));
        ctx.translate(p.x, p.y);
        ctx.rotate((p.rotation * Math.PI) / 180);
        ctx.fillStyle = p.color;

        if (p.shape === "circle") {
          ctx.beginPath();
          ctx.arc(0, 0, p.w / 2, 0, Math.PI * 2);
          ctx.fill();
        } else {
          ctx.fillRect(-p.w / 2, -p.h / 2, p.w, p.h);
        }

        ctx.restore();
      });

      if (!allDone) {
        animFrameRef.current = requestAnimationFrame(draw);
      } else {
        ctx.clearRect(0, 0, canvas.width, canvas.height);
      }
    };

    draw();

    return () => {
      if (animFrameRef.current) cancelAnimationFrame(animFrameRef.current);
      if (canvas) ctx.clearRect(0, 0, canvas.width, canvas.height);
    };
  }, [AppliedCouponPopup]);

  if (!AppliedCouponPopup) return null;

  return (
    <div className="alert-coupon-overlay">

      {/* Confetti Canvas */}
      <canvas
        ref={canvasRef}
        style={{
          position: "fixed",
          top: 0,
          left: 0,
          width: "100%",
          height: "100%",
          pointerEvents: "none",
          zIndex: 1001,
        }}
      />

      <div className="alert-coupon-modal">

        {/* Floating Icon */}
        <div className="alert-coupon-icon-wrapper">
          <img src={couponDiscount} alt="discount" />
        </div>

        {/* Close Button */}
        <div className="alert-coupon-close" onClick={onClose}>×</div>

        {/* Content */}
        <p className="alert-coupon-code">'{DisplayCouponCode}' applied</p>

        <h2 className="alert-coupon-title">
          ₹{CouponDiscountPrice} savings with this <br />coupon.
        </h2>

        <p className="alert-coupon-subtext">
          Woohoo! Your coupon is successfully applied
        </p>

        {/* CTA */}
        <button className="alert-coupon-btn" onClick={onConfirm}>
          YAY!
        </button>
      </div>
    </div>
  );
};

export default AppliedCouponAlert;